/*
 * ===============================================================================================================
 *                                Copyright 2022, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IAttribute } from '../../../models/Policies/PolicyContract';
import { ISelect } from '../../../models/Roles/RolesContracts';
import { AutocompleteChangeDetails, AutocompleteChangeReason } from '../../CustomList/types';

export function CommonFunctions(
  attributes: any,
  attributesFormError: any,
  setAttributeFormData: any,
  setAttributeFormErrorData: any,
  attributeList: any,
  dispatch: any,
  index: number,
  setEnumValue?: any,
  setValueTextFieldType?: any
) {
  const onSelectionChange = (
    name: string,
    index: number,
    event: { target: { name: string; value: ISelect | ISelect[] | string } }
  ) => {
    const attributeArr = attributes.map((a: IAttribute, i: number) => {
      if (i === index) {
        return {
          ...a,
          [name]: event.target.value
        };
      } else {
        return a;
      }
    });
    dispatch(setAttributeFormData(attributeArr));
    const attributesFormErrorArr = attributesFormError.map((a: IAttribute, i: number) => {
      if (i === index) {
        return {
          ...a,
          [name]: ''
        };
      } else {
        return a;
      }
    });
    dispatch(setAttributeFormErrorData(attributesFormErrorArr));
  };
  const searchableListSelection = (
    event: React.ChangeEvent<any>,
    value: any,
    _reason: AutocompleteChangeReason,
    _details?: AutocompleteChangeDetails<any> | undefined
  ) => {
    if (value) {
      let filterAttribute = attributeList.find(
        (attribute: any) => attribute.displayName && attribute.displayName.toUpperCase() === value?.name?.toUpperCase()
      );
      const finalAttributes = attributes.map((item: any, i: number) => {
        if (i === index) {
          if (event?.target?.id.startsWith('autocomplete-search-data-attribute')) {
            if (value.value.type === 'string' && value.value.enum && value.value.enum.length > 0) {
              const enums = value.value.enum.map((item: any) => {
                return {
                  key: item,
                  displayName: item
                };
              });
              setEnumValue(enums);
              setValueTextFieldType(false);
              return {
                ...item,
                attribute: filterAttribute,
                value: []
              };
            } else {
              setValueTextFieldType(true);
              return {
                ...item,
                attribute: filterAttribute,
                value: ''
              };
            }
          } else {
            return {
              ...item,
              attribute: filterAttribute
            };
          }
        } else {
          return item;
        }
      });
      dispatch(setAttributeFormData(finalAttributes));
    }
  };
  const handleRowDelete = (index: number) => {
    const attributeArr = attributes.filter((_a: IAttribute, i: number) => i !== index);
    dispatch(setAttributeFormData(attributeArr));
    const attributesFormErrorArr = attributesFormError.filter((_a: IAttribute, i: number) => i !== index);
    dispatch(setAttributeFormErrorData(attributesFormErrorArr));
  };
  return {
    onSelectionChange: onSelectionChange,
    searchableListSelection: searchableListSelection,
    handleRowDelete: handleRowDelete
  };
}
